"use client";

import { useI18n } from "@llmgateway/i18n/react";

type TranslationValues = Record<string, string | number | boolean>;

interface I18nTextProps {
	id: string;
	values?: TranslationValues;
}

export function I18nText({ id, values }: I18nTextProps) {
	const { t } = useI18n();

	return <>{t(id, values)}</>;
}
